import { compile } from 'path-to-regexp';
import { Params } from './http-client.types';

const domainRegExp = /[a-zA-z]+:\/\/[^/]*/;

function isUrlContainsDomain(url: string): boolean {
  return !!url.match(domainRegExp);
}

export function updatePath(url: string, params: Params): string {
  let domain = '';
  let path = `${url}`;

  if (isUrlContainsDomain(url)) {
    [domain] = url.match(domainRegExp) as RegExpMatchArray;
    path = url.slice(domain.length);
  }

  return domain + compile(path)(params);
}
